<div class="container-fluid py-3 px-2 px-md-4">

  <!-- CARD PRINCIPAL -->
  <div class="card shadow-lg border-0 rounded-4 w-100 source-fieldwork-card">

    <!-- HEADER -->
    <div class="card-header text-center py-3 rounded-top-4" style="background-color:#1e3a8a; color:white;">
      <h3 class="mb-0 fw-semibold">Levantamiento Fuente</h3>
    </div>

    <!-- BODY -->
    <div class="card-body bg-light p-4 p-md-5 rounded-bottom-4 source-fieldwork-body">

      <!-- ✅ FORM CORRECTO -->
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>


        <!-- ========================= -->
        <!-- SECCIÓN: IDENTIFICACIÓN -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Identificación</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <div class="d-flex justify-content-between align-items-center gap-2 mb-2 source-fieldwork-inline-action">
              <label class="form-label fw-semibold mb-0">Código INE</label>
              <button type="button" class="btn btn-info btn-sm text-white source-fieldwork-inline-button" (click)="generateFountainNumber()"
                [disabled]="generatingNumber()">
                @if (generatingNumber()) {
                <span class="spinner-border spinner-border-sm me-1"></span>
                Generando...
                } @else {
                Generar
                }
              </button>
            </div>
            <input type="text" formControlName="codigoINE" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('codigoINE')" placeholder="Número de fuente" />
            @if (isInvalid('codigoINE')) {
            <div class="invalid-feedback">{{ getErrorText('codigoINE') }}</div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Razón Social</label>
            <input type="text" formControlName="razonSocial" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('razonSocial')" />
            @if (isInvalid('razonSocial')) {
            <div class="invalid-feedback">{{ getErrorText('razonSocial') }}</div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Nombre</label>
            <input type="text" formControlName="nombre" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('nombre')" />
            @if (isInvalid('nombre')) {
            <div class="invalid-feedback">{{ getErrorText('nombre') }}</div>
            }
          </div>
        </div>

        <!-- ============================== -->
        <!-- SECCIÓN: DIRECCIÓN Y UBICACIÓN -->
        <!-- ============================== -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Dirección y Ubicación</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-12">
            <label class="form-label fw-semibold">Dirección</label>
            <input type="text" formControlName="direccion" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('direccion')" />
            @if (isInvalid('direccion')) {
            <div class="invalid-feedback">{{ getErrorText('direccion') }}</div>
            }
          </div>



          <div class="row g-3">

            <!-- Departamento -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Departamento</label>
              <select formControlName="fkDepartamento" class="form-control form-control-lg fieldwork-desktop-select"
                [class.is-invalid]="isInvalid('fkDepartamento')" (change)="onDepartamentoChange()">

                @for (d of departaments; track d.id) {
                <option [ngValue]="d.id">{{ d.nombre }}</option>
                }
              </select>
              <div class="fieldwork-mobile-picker">
                <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                  (click)="openMobileSelect('fkDepartamento', 'Departamento', getDepartamentoMobileOptions())">
                  <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkDepartamento', 'Seleccione departamento') }}</span>
                  <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
                </button>
              </div>

              @if (isInvalid('fkDepartamento')) {
              <div class="invalid-feedback">
                {{ getErrorText('fkDepartamento') }}
              </div>
              }
            </div>

            <!-- Municipio -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Municipio</label>
              <select formControlName="fkMunicipio" class="form-control form-control-lg fieldwork-desktop-select"
                [class.is-invalid]="isInvalid('fkMunicipio')" (change)="onMunicipioChange()">

                @for (m of municipalities(); track m.id) {
                <option [ngValue]="m.id">{{ m.nombre }}</option>
                }
              </select>
              <div class="fieldwork-mobile-picker">
                <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                  (click)="openMobileSelect('fkMunicipio', 'Municipio', getMunicipioMobileOptions())">
                  <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkMunicipio', 'Seleccione municipio') }}</span>
                  <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
                </button>
              </div>

              @if (isInvalid('fkMunicipio')) {
              <div class="invalid-feedback">
                {{ getErrorText('fkMunicipio') }}
              </div>
              }
            </div>

            <!-- Zona -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Zona</label>
              <input type="number" formControlName="zona" class="form-control form-control-lg" min="0" step="1"
                placeholder="Zona" (input)="onZonaChange()" />
            </div>

            <!-- Código Postal -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Código Postal</label>

              <!-- Visible para el usuario -->
              <input type="text" class="form-control form-control-lg" [value]="codigoPostalDescripcion" readonly />

              <!-- Valor real que viaja al backend -->
              <input type="hidden" formControlName="fkCodigoPostal" />

              @if (isInvalid('fkCodigoPostal')) {
              <div class="invalid-feedback d-block">
                {{ getErrorText('fkCodigoPostal') }}
              </div>
              }
            </div>


          </div>

        </div>



        <!-- ========================= -->
        <!-- SECCIÓN: GEOLOCALIZACIÓN -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Geolocalización</h5>



        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Latitud</label>
            <input type="number" step="0.0000001" formControlName="gpsLatitud" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('gpsLatitud')" />
            @if (isInvalid('gpsLatitud')) {
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Longitud</label>
            <input type="number" step="0.0000001" formControlName="gpsLongitud" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('gpsLongitud')" />
            @if (isInvalid('gpsLatitud')) {
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Altitud</label>
            <input type="number" formControlName="gpsAltitud" class="form-control form-control-lg" />
          </div>

          <div class="row g-3 align-items-end mb-4">

            <!-- Fecha GPS -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Fecha GPS</label>
              <input type="datetime-local" formControlName="gpsFecha" class="form-control form-control-lg"
                [class.is-invalid]="isInvalid('gpsFecha')" />
              @if (isInvalid('gpsLatitud')) {
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
              }
            </div>

            <!-- Botón ubicación -->
            <div class="col-md-6">
              <label class="form-label fw-semibold invisible">Ubicación</label>
              <button type="button"
                class="btn btn-info btn-lg text-white w-100 d-flex align-items-center justify-content-center gap-2"
                [disabled]="geoLoading()" (click)="useCurrentLocation()">

                @if (geoLoading()) {
                <span class="spinner-border spinner-border-sm"></span>
                Obteniendo ubicación...
                } @else {
                <i class="bi bi-geo-alt-fill"></i>
                Usar ubicación actual
                }

              </button>
            </div>
          </div>



        </div>


        <!-- ========================= -->
        <!-- SECCIÓN: CONTACTO -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Contacto</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Teléfonos</label>
            <input type="text" formControlName="telefonos" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('telefonos')" placeholder="Ej: 3245-1540 Ext 357" />
            @if (isInvalid('telefonos')) {
            <div class="invalid-feedback">{{ getErrorText('telefonos') }}</div>
            }
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Email</label>
            <input type="email" formControlName="email" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('email')" (blur)="applyDefaultMainEmail()" />
            @if (isInvalid('email')) {
            <div class="invalid-feedback">{{ getErrorText('email') }}</div>
            }
          </div>
        </div>

        <!-- ========================= -->
        <!-- SECCIÓN: PROGRAMACIÓN -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Programación de Visitas</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Usuario Responsable</label>
            <select formControlName="fkUsuario" class="form-select form-select-lg fieldwork-desktop-select"
              [class.is-invalid]="isInvalid('fkUsuario')">
              @for (u of usuarios(); track u.pk) {
              <option [ngValue]="u.pk">{{ u.nombre ?? u.descripcion }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('fkUsuario', 'Usuario Responsable', getUsuarioMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkUsuario', 'Seleccione usuario responsable') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
            @if (isInvalid('fkUsuario')) {
            <div class="invalid-feedback">{{ getErrorText('fkUsuario') }}</div>
            }
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold">
              Periodo
              @if (periodoTitulo() && periodoTitulo().toLowerCase() !== 'periodo') {
              <span class="text-muted">({{ periodoTitulo() }})</span>
              }
            </label>

            <select class="form-select form-select-lg fieldwork-desktop-select" formControlName="periodo">
              @for (i of periodos(); track i) {
              <option [value]="i">{{ periodoTitulo() }} {{ i }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('periodo', periodoTitulo(), getPeriodoMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('periodo', 'Seleccione período') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Orden de Ruta</label>
            <input
              type="number"
              formControlName="ordenRuta"
              class="form-control form-control-lg"
              min="0"
              step="1"
              inputmode="numeric"
              placeholder="0"
              (keydown)="preventInvalidIntegerInput($event)"
              (input)="normalizeNonNegativeInteger('ordenRuta')" />
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Periodicidad</label>
            <select formControlName="fkPeriodicidadVisita" class="form-select form-select-lg fieldwork-desktop-select"
              [class.is-invalid]="isInvalid('fkPeriodicidadVisita')">
              <option [ngValue]="null">Seleccione...</option>
              @for (p of periodicidades(); track p.pk) {
              <option [ngValue]="p.pk">{{ p.descripcion }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('fkPeriodicidadVisita', 'Periodicidad', getPeriodicidadMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkPeriodicidadVisita', 'Seleccione periodicidad') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
            @if (isInvalid('fkPeriodicidadVisita')) {
            <div class="invalid-feedback">{{ getErrorText('fkPeriodicidadVisita') }}</div>
            }
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Día de Visita</label>
            <select formControlName="fkDiaVisita" class="form-select form-select-lg fieldwork-desktop-select"
              [class.is-invalid]="isInvalid('fkDiaVisita')">
              @for (d of diasVisita(); track d.pk) {
              <option [ngValue]="d.pk">{{ d.descripcion }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('fkDiaVisita', 'Día de Visita', getDiaVisitaMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkDiaVisita', 'Seleccione día de visita') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
            @if (isInvalid('fkDiaVisita')) {
            <div class="invalid-feedback">{{ getErrorText('fkDiaVisita') }}</div>
            }
          </div>
        </div>

        <!-- ========================= -->
        <!-- SECCIÓN: JORNADAS -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Jornadas</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label fw-semibold">Inicio 1ra Jornada</label>
            <input type="time" formControlName="horaInicioPrimeraJornada" class="form-control form-control-lg"
              [class.is-invalid]="isHoraInvalidaPrimera()" />
          </div>
          <div class="col-md-3">
            <label class="form-label fw-semibold">Fin 1ra Jornada</label>
            <input type="time" formControlName="horaFinalPrimeraJornada" class="form-control form-control-lg"
              [class.is-invalid]="isHoraInvalidaPrimera()" />

            @if (isHoraInvalidaPrimera()) {
            <div class="invalid-feedback d-block">
              La hora final debe ser mayor a la inicial y tener una duración válida.
            </div>
            }
          </div>
          <div class="col-md-3">
            <label class="form-label fw-semibold">Inicio 2da Jornada</label>
            <input type="time" formControlName="horaInicioSegundaJornada" class="form-control form-control-lg"
              [class.is-invalid]="isHoraInvalidaSegunda()" />
          </div>
          <div class="col-md-3">
            <label class="form-label fw-semibold">Fin 2da Jornada</label>
            <input type="time" formControlName="horaFinalSegundaJornada" class="form-control form-control-lg"
              [class.is-invalid]="isHoraInvalidaSegunda()" />
            @if (isHoraInvalidaSegunda()) {
            <div class="invalid-feedback d-block">
              La hora final debe ser mayor a la inicial y tener una duración válida.
            </div>
            }

            @if (form.errors?.['traslapeJornadas']) {
            <div class="invalid-feedback d-block">
              La segunda jornada se traslapa con la primera.
            </div>
            }

          </div>
        </div>

        <!-- ========================= -->
        <!-- SECCIÓN: CLASIFICACIÓN -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Clasificación y Requisitos</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Requiere Audio</label>
            <select formControlName="requiereAudio" class="form-select form-select-lg fieldwork-desktop-select">
              <option value="S">Sí</option>
              <option value="N">No</option>
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('requiereAudio', 'Requiere Audio', yesNoOptions)">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('requiereAudio', 'Seleccione una opción') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Requiere Imagen</label>
            <select formControlName="requiereImagen" class="form-select form-select-lg fieldwork-desktop-select">
              <option value="S">Sí</option>
              <option value="N">No</option>
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('requiereImagen', 'Requiere Imagen', yesNoOptions)">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('requiereImagen', 'Seleccione una opción') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">NIT</label>
            <input type="text" formControlName="nit" class="form-control form-control-lg"
              [class.is-invalid]="isInvalid('nit')" placeholder="Ej: CF, 4564854K, ND" />
            @if (isInvalid('nit')) {
            <div class="invalid-feedback">{{ getErrorText('nit') }}</div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Actividad Empresa</label>
            <select formControlName="fkActividadEmpresa" class="form-select form-select-lg fieldwork-desktop-select"
              [class.is-invalid]="isInvalid('fkActividadEmpresa')">
              <option [ngValue]="null">Seleccione...</option>
              @for (a of actividades(); track a.pk) {
              <option [ngValue]="a.pk">{{ a.descripcion }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('fkActividadEmpresa', 'Actividad Empresa', getActividadMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkActividadEmpresa', 'Seleccione actividad empresa') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
            @if (isInvalid('fkActividadEmpresa')) {
            <div class="invalid-feedback">{{ getErrorText('fkActividadEmpresa') }}</div>
            }
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Tamaño Empresa</label>
            <select formControlName="fkTamanoEmpresa" class="form-select form-select-lg fieldwork-desktop-select"
              [class.is-invalid]="isInvalid('fkTamanoEmpresa')">
              <option [ngValue]="null">Seleccione...</option>
              @for (t of tamanios(); track t.pk) {
              <option [ngValue]="t.pk">{{ t.descripcion }}</option>
              }
            </select>
            <div class="fieldwork-mobile-picker">
              <button type="button" class="btn btn-outline-info fieldwork-mobile-picker__button"
                (click)="openMobileSelect('fkTamanoEmpresa', 'Tamaño Empresa', getTamanoEmpresaMobileOptions())">
                <span class="fieldwork-mobile-picker__value">{{ getMobileSelectionLabel('fkTamanoEmpresa', 'Seleccione tamaño empresa') }}</span>
                <span class="fieldwork-mobile-picker__action"><i class="bi bi-search"></i>Buscar</span>
              </button>
            </div>
            @if (isInvalid('fkTamanoEmpresa')) {
            <div class="invalid-feedback">{{ getErrorText('fkTamanoEmpresa') }}</div>
            }
          </div>
        </div>

        <!-- ========================= -->
        <!-- SECCIÓN: INFO ADICIONAL -->
        <!-- ========================= -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Información Adicional</h5>
        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Código CIIU</label>
            <input type="text" formControlName="codigoCIIU" class="form-control form-control-lg" />
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Comentarios</label>
            <textarea formControlName="comentarios" class="form-control form-control-lg"></textarea>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Referencia</label>
            <input type="text" formControlName="referencia" class="form-control form-control-lg" />
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Información Adicional</label>
            <input type="text" formControlName="informacionAdicional" class="form-control form-control-lg" />
          </div>

          <div class="col-md-12">
            <label class="form-label fw-semibold">Estado</label>
            <select formControlName="estado" class="form-select form-select-lg">
              <option value="P">Pendiente</option>
            </select>
          </div>



          <!-- ALERTA CAMPOS FALTANTES -->
          @if (false) {
          <div class="alert alert-warning shadow-sm border-0 rounded-3 mb-4">
            <div class="fw-semibold mb-1">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              Te faltan campos obligatorios:
            </div>
            <ul class="mb-0">
              @for (f of missingFields(); track f) {
              <li>{{ f }}</li>
              }
            </ul>
          </div>
          }
        </div>

        <!-- ========================= -->
        <!-- SECCIÓN CONTACTOS -->
        <!-- ========================= -->
        <div class="mt-5 p-4 bg-white rounded-4 border shadow-sm">

          <!-- HEADER -->
          <div class="d-flex justify-content-between align-items-center mb-3 source-fieldwork-section-header">
            <h4 class="text-primary mb-0">
              <i class="bi bi-people-fill me-2"></i>
              Contactos de la Fuente
            </h4>

            <button
              type="button"
              class="btn text-white source-fieldwork-section-button"
              [class.btn-info]="!showContactForm()"
              [class.btn-danger]="showContactForm()"
              (click)="toggleContactForm()">
              <i class="bi bi-person-plus me-1"></i>
              @if (!showContactForm()) {
              Agregar contacto
              } @else {
              Cancelar
              }
            </button>
          </div>

          <!-- ========================= -->
          <!-- FORM AGREGAR / EDITAR -->
          <!-- ========================= -->
          @if (showContactForm()) {
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-light fw-semibold">
              <i class="bi bi-person-lines-fill me-2"></i>
              Información del Contacto
            </div>

            <div class="card-body" [formGroup]="contactForm">

              <div class="row g-3">

                <div class="col-md-6">
                  <label class="form-label fw-semibold">
                    Nombre <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" formControlName="name"
                    placeholder="Nombre completo del contacto">
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Título</label>
                  <input type="text" class="form-control" formControlName="title" placeholder="Ej: Lic., Ing., Dr.">
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Cargo</label>
                  <input type="text" class="form-control" formControlName="position" placeholder="Ej: Gerente">
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Teléfonos</label>
                  <input type="text" class="form-control" formControlName="phones"
                    placeholder="Ej: 3245-1540 Ext 357">
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email" placeholder="correo@empresa.com"
                    (blur)="applyDefaultContactEmail()">
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Orden</label>
                  <input type="number" min="0" class="form-control" formControlName="order">
                </div>

                <div class="col-12">
                  <label class="form-label fw-semibold">Comentarios</label>
                  <textarea rows="3" class="form-control" formControlName="comments"
                    placeholder="Observaciones del contacto"></textarea>
                </div>

              </div>

              <!-- BOTONES -->
              <div class="d-flex justify-content-end gap-2 mt-3 source-fieldwork-form-actions">
                <button type="button" class="btn btn-danger text-white source-fieldwork-form-button" (click)="toggleContactForm()">
                  Cancelar
                </button>

                <button type="button" class="btn btn-info text-white source-fieldwork-form-button" (click)="saveContact()">
                  @if (editingIndex === null) {
                  <i class="bi bi-plus-circle me-2"></i>
                  Agregar contacto
                  } @else {
                  <i class="bi bi-check-circle me-2"></i>
                  Actualizar contacto
                  }
                </button>
              </div>

            </div>
          </div>
          }

          <!-- ========================= -->
          <!-- TABLA CONTACTOS -->
          <!-- ========================= -->
          <div class="table-responsive source-fieldwork-contacts-table-wrap">
            <table class="table table-striped align-middle source-fieldwork-contacts-table">
              <thead class="table-light">
                <tr>
                  <th>Nombre</th>
                  <th>Cargo</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th>Orden</th>
                  <th class="text-end">Acciones</th>
                </tr>
              </thead>

              <tbody>

                @for (c of pendingContacts; track $index) {
                <tr>
                  <td data-label="Nombre">{{ c.name }}</td>
                  <td data-label="Cargo">{{ c.position }}</td>
                  <td data-label="Teléfono">{{ c.phones }}</td>
                  <td data-label="Email">{{ c.email }}</td>
                  <td data-label="Orden">{{ c.order }}</td>
                  <td class="text-end source-fieldwork-contacts-actions-cell" data-label="Acciones">
                    <div class="d-inline-flex flex-wrap justify-content-end gap-2 source-fieldwork-table-actions">
                      <button class="btn btn-outline-info" (click)="editContact(c, $index)">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="btn btn-outline-info" (click)="removeContact($index)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                }

                @if (pendingContacts.length === 0) {
                <tr>
                  <td colspan="6" class="text-center text-muted">
                    No hay contactos agregados
                  </td>
                </tr>
                }

              </tbody>
            </table>
          </div>

        </div>

        <!-- ========================= -->
        <!-- ✅ SECCIÓN ARTÍCULOS (MISMO CONTENIDO, MEJOR LOOK) -->
        <!-- ========================= -->
        <div [formGroup]="form" class="card p-4 mt-5 shadow-sm mb-4 source-fieldwork-article-section">
          <app-source-article></app-source-article>
        </div>

        <!-- ========================= -->
        <!-- BOTÓN FINAL -->
        <!-- ========================= -->
        @if (false) {
        <div class="alert alert-success shadow-sm border-0 rounded-3 mb-4">
          <i class="bi bi-check-circle-fill me-2"></i>
          <strong>¡Guardado exitosamente!</strong>
          La fuente fue registrada correctamente.
        </div>
        }
        <div class="d-flex flex-column flex-md-row justify-content-center gap-3 mt-5 pt-4 source-fieldwork-submit-actions">

          <!-- CANCELAR -->
          <button type="button" class="btn btn-danger text-white btn-lg px-5 w-100 source-fieldwork-submit-button" [disabled]="loading()"
            (click)="onCancel()">
            <i class="bi bi-x-circle me-2"></i>
            Cancelar
          </button>

          <!-- GUARDAR -->
          <button type="submit" class="btn btn-info btn-lg text-white px-5 w-100 source-fieldwork-submit-button" [disabled]="loading() || success()">
            <i class="bi bi-save me-2"></i>
            Guardar levantamiento
          </button>

        </div>


      </form>
    </div>
  </div>

</div>

@if (mobileSelectOpen()) {
<div class="fieldwork-mobile-select-overlay" (click)="closeMobileSelect()">
  <div class="fieldwork-mobile-select-sheet" (click)="$event.stopPropagation()">
    <div class="fieldwork-mobile-select-sheet__header">
      <div>
        <small class="fieldwork-mobile-select-sheet__eyebrow">Selección rápida</small>
        <h5 class="mb-0">{{ mobileSelectTitle() }}</h5>
      </div>
      <button type="button" class="btn-close" aria-label="Cerrar" (click)="closeMobileSelect()"></button>
    </div>

    <div class="fieldwork-mobile-select-sheet__search">
      <div class="input-group input-group-lg">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control" placeholder="Buscar opción..."
          [value]="mobileSelectQuery()" (input)="updateMobileSelectQuery($event)" />
      </div>
    </div>

    <div class="fieldwork-mobile-select-sheet__options">
      @if (filteredMobileSelectOptions().length === 0) {
      <div class="fieldwork-mobile-select-sheet__empty">No se encontraron opciones.</div>
      } @else {
      @for (option of filteredMobileSelectOptions(); track option.value) {
      <button type="button" class="fieldwork-mobile-select-option"
        [class.is-active]="isActiveMobileSelectOption(option)"
        (click)="applyMobileSelectOption(option)">
        <span>{{ option.label }}</span>
        @if (isActiveMobileSelectOption(option)) {
        <i class="bi bi-check-circle-fill"></i>
        }
      </button>
      }
      }
    </div>
  </div>
</div>
}

<app-success-alert-modal
  [visible]="success()"
  [title]="'Información'"
  [message]="successMessage()"
  [variant]="'info'"
  (closed)="closeSuccessModal()">
</app-success-alert-modal>

<app-validation-summary-modal
  [visible]="showValidationModal()"
  [items]="missingFields()"
  [title]="'Faltan campos obligatorios'"
  [message]="'Completa esta información antes de guardar.'"
  (closed)="closeValidationModal()">
</app-validation-summary-modal>
